import Vue from 'vue'

import axios from 'axios'
import httpAxios from '@websanova/vue-auth/drivers/http/axios.1.x.js'
import routerVueRouter from '@websanova/vue-auth/dist/drivers/router/vue-router.2.x.esm.js'
import VueAxios from 'vue-axios'
import VueAuth from '@websanova/vue-auth'
import router from '@/router'

Vue.use(VueAxios, axios)
Vue.axios.defaults.baseURL = process.env.VUE_APP_URL

Vue.router = router

Vue.use(VueAuth, {
  auth: require('@/shared/jwt/jwt.js'),
  http: httpAxios,
  router: routerVueRouter,
  loginData: { redirect: '/' },
  logoutData: { redirect: '/login' },
  refreshData: { enabled: false }
})
